import { KeyboardEvent, MouseEvent } from 'react';

type onClick = (n: null | MouseEvent) => void;

const onClickProps = (
  onClick?: onClick,
  disabled?: boolean,
):
  | Record<string, never>
  | { onClick: onClick; onKeyPress: (e: KeyboardEvent) => void } => {
  if (disabled || !onClick) {
    return {};
  }

  return {
    onClick,
    onKeyPress: (e: KeyboardEvent) => e.key === 'Enter' && onClick(null),
  };
};

export default onClickProps;
